import {AlertTriangle} from 'lucide-react';
import type {ReactNode} from 'react';

import {cn} from '@/utils/ui';

import {Typography} from '../ui/typography';

export type ErrorMessageTemplateProps = {
  title: string;
  subtitle?: string;
  children?: ReactNode;
  icon?: ReactNode;
  className?: string;
};

function ErrorMessageTemplate({
  children,
  title,
  subtitle,
  className,
  icon,
}: ErrorMessageTemplateProps) {
  return (
    <div
      className={cn(
        'flex h-full flex-col items-center justify-center gap-2',
        className
      )}
    >
      {icon ?? (
        <AlertTriangle size={50} className="animate-shake text-red-500" />
      )}
      <Typography variant="h1" asChild className="text-center">
        <h1>{title}</h1>
      </Typography>
      {subtitle && (
        <Typography className="mt-5 text-center">{subtitle}</Typography>
      )}
      {children && <div className="mt-3">{children}</div>}
    </div>
  );
}

export default ErrorMessageTemplate;
